import { FC } from 'react';
import { ArrowBackIos } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Stack } from '@mui/material';

import { PAYMENT_STEP } from '~common';
import { AddCard } from '~components/atoms/new-step-three/AddCard';
import { StripeElements } from '~components/molecules/StripeElements';
import { LocalizationTypography } from '~components/organisms/localization';
import { stripeElementsOptions } from '~configs/stripe';
import { usePaymentStepContext } from '~providers';

export const AddPaymentMethod: FC = () => {
  const { handleSetPaymentStep } = usePaymentStepContext();

  return (
    <>
      <Stack direction="row">
        <IconButton
          aria-label="back"
          size="small"
          color="inherit"
          sx={{ paddingY: 0 }}
          onClick={() => handleSetPaymentStep(PAYMENT_STEP.RENT_A_CHARGER)}
        >
          <ArrowBackIos />
        </IconButton>
        <LocalizationTypography
          textId="app.rentalPage.newStepThree.text.addCard"
          defaultText="Add Card"
          variant="Poppins/Heading-3"
        />
      </Stack>

      {/* FORM */}
      <StripeElements options={stripeElementsOptions}>
        <AddCard />
      </StripeElements>
    </>
  );
};
